import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './SiteFooter.css';

/**
 * Shared site footer: Product, Solutions, Resources, Company.
 * Use `children` to render the bottom bar (e.g. copyright + theme/language on homepage).
 */
export default function SiteFooter({ children }) {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <nav className="site-footer__nav" aria-label="Footer navigation">
          <div className="site-footer__column">
            <h4 className="site-footer__heading">{t('product')}</h4>
            <ul className="site-footer__list" aria-label={t('product')}>
              <li><Link to="/Overview" className="site-footer__link" title={t('overview')}>{t('overview')}</Link></li>
              <li><Link to="/Features" className="site-footer__link" title={t('features')}>{t('features')}</Link></li>
              <li><Link to="/Apps" className="site-footer__link" title={t('apps') || 'Apps'}>{t('apps') || 'Apps'}</Link></li>
              <li><Link to="/pricing" className="site-footer__link" title={t('pricing')}>{t('pricing')}</Link></li>
              <li><Link to="/Download" className="site-footer__link" title={t('download')}>{t('download')}</Link></li>
            </ul>
          </div>
          <div className="site-footer__column">
            <h4 className="site-footer__heading">{t('solutions')}</h4>
            <ul className="site-footer__list">
              <li><Link to="/Teams" className="site-footer__link">{t('teams')}</Link></li>
              <li><Link to="/Enterprise" className="site-footer__link">{t('enterprise')}</Link></li>
              <li><Link to="/Education" className="site-footer__link">{t('education')}</Link></li>
              <li><Link to="/Integrations" className="site-footer__link">{t('integrations')}</Link></li>
            </ul>
          </div>
          <div className="site-footer__column">
            <h4 className="site-footer__heading">{t('resources')}</h4>
            <ul className="site-footer__list">
              <li><Link to="/docs" className="site-footer__link">{t('docs')}</Link></li>
              <li><Link to="/TechArticlesPage" className="site-footer__link">{t('techArticles')}</Link></li>
              <li><Link to="/Resources" className="site-footer__link">{t('resources')}</Link></li>
              <li><Link to="/Blog" className="site-footer__link">{t('blog')}</Link></li>
              <li><Link to="/Support" className="site-footer__link">{t('support')}</Link></li>
            </ul>
          </div>
          <div className="site-footer__column">
            <h4 className="site-footer__heading">{t('company')}</h4>
            <ul className="site-footer__list">
              <li><Link to="/About" className="site-footer__link">{t('about')}</Link></li>
              <li><Link to="/Careers" className="site-footer__link">{t('careers')}</Link></li>
              <li><Link to="/Contact" className="site-footer__link">{t('contact') || 'Contact'}</Link></li>
              <li><Link to="/delete-data" className="site-footer__link">{t('deleteMyData', { defaultValue: 'Delete my data' })}</Link></li>
              <li><Link to="/TermsOfService" className="site-footer__link">{t('terms')}</Link></li>
              <li><Link to="/PrivacyPolicy" className="site-footer__link">{t('privacy')}</Link></li>
            </ul>
          </div>
        </nav>
        <section className="site-footer__social" aria-labelledby="site-footer-follow">
          <h4 id="site-footer-follow" className="site-footer__social-heading">
            {t('followUs')}
          </h4>
          <div className="site-footer__social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61587216670698"
              className="site-footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('facebook')}
            </a>
            <a href="https://www.instagram.com/zolaid1" className="site-footer__social-link" target="_blank" rel="noopener noreferrer">
              {t('instagram')}
            </a>
            <a
              href="https://www.linkedin.com/company/zolaid1/"
              className="site-footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('linkedin')}
            </a>
            <a href="https://x.com/zolaid1" className="site-footer__social-link" target="_blank" rel="noopener noreferrer">
              X
            </a>
          </div>
        </section>
        <div className="site-footer__bottom">
          {children != null ? (
            children
          ) : (
            <>
              <span className="site-footer__copyright">{t('copyright')}</span>
              <div className="site-footer__legal">
                <Link to="/PrivacyPolicy" className="site-footer__link">Privacy</Link>
                <span className="site-footer__sep" aria-hidden>·</span>
                <Link to="/TermsOfService" className="site-footer__link">Terms</Link>
                <span className="site-footer__sep" aria-hidden>·</span>
                <Link to="/delete-data" className="site-footer__link">Delete my data</Link>
                <span className="site-footer__sep" aria-hidden>·</span>
                <Link to="/Contact" className="site-footer__link">Contact</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
